/* eslint-disable no-nested-ternary */
import React from 'react'
import { SkeletonLoader } from 'Components/SharedComponents/SkeletonLoader/SkeletonLoader'
import { Resource } from 'Generated/academy-graphql-types'
import AcademyResourceTaskItem from '../ResourceTasks/AcademyResourceTaskItem'
import {
  ExternalLink,
  SupplementalItem,
  TaskItemRowTitle,
} from './TaskItem.styled'

type TaskLinksProps = {
  resource: Resource | null | undefined
  linkUrl: string | null
  linkText: string | null
  isCompleted: boolean
  isResourceLoading: boolean
  onAcademyLinkClick: () => void
}

export const TaskLinks = ({
  resource,
  linkUrl,
  linkText,
  isCompleted,
  isResourceLoading,
  onAcademyLinkClick,
}: TaskLinksProps) => (
  <>
    {isResourceLoading && (
      <SupplementalItem>
        <SkeletonLoader
          styles={{
            height: '10px',
            width: '50%',
          }}
        />
      </SupplementalItem>
    )}
    {resource && !isResourceLoading && (
      <SupplementalItem>
        <AcademyResourceTaskItem
          resource={resource}
          completed={isCompleted}
          dispatchTaskAcademyLinkClicked={onAcademyLinkClick}
        />
      </SupplementalItem>
    )}
    {linkUrl && (
      <SupplementalItem>
        <ExternalLink href={linkUrl} target='_blank' rel='noopener noreferrer'>
          <TaskItemRowTitle>{linkText || linkUrl}</TaskItemRowTitle>
        </ExternalLink>
      </SupplementalItem>
    )}
  </>
)
